var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"subTitle"},[_c('div',{staticClass:"content-wrap"},[_c('h2',[_vm._v(_vm._s(_vm.titleData.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }